import React, { Fragment } from 'react';

import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

const FormatRupiah = ({ value, isSymbol, decimalScale, prefix = 'Rp ' }) => (
  <NumberFormat
    value={value || 0}
    displayType="text"
    thousandSeparator="."
    decimalSeparator=","
    decimalScale={decimalScale}
    prefix={prefix}
    renderText={(parseValue) => {
      let revaluated = 0;
      if (isSymbol) {
        if (parseFloat(value) === 0) {
          revaluated = parseValue;
        } else if (parseFloat(value) > 0) {
          revaluated = `+${parseValue}`;
        } else {
          revaluated = `${parseValue}`;
        }
      } else {
        revaluated = parseValue;
      }
      return <>{revaluated}</>;
    }}
  />
);

FormatRupiah.propTypes = {
  decimalScale: PropTypes.number,
  value: PropTypes.number,
  isSymbol: PropTypes.bool,
  prefix: PropTypes.string,
};

FormatRupiah.defaultProps = {
  decimalScale: 0,
  isSymbol: false,
  value: 0,
  prefix: `${'Rp'} `,
};

export default FormatRupiah;
